import React, { Component } from "react";
import InputMask from "react-input-mask";
import $ from "jquery";

export default class CampoNroTelefono extends Component {

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  };
  componentDidMount() {

  }

  onChange = (event) => {
    this.props.phoneSelectorValue(event.target.value);
  

    
  }


  

  render() {
   //console.log("FONE "+this.props.phoneSelector)
    return (
      <div className="row">
          <div className="col-md-12">  
          <label className="input-label">Teléfono de Contacto *</label>      
            <div className="form-group">
                                
              <InputMask id="telefono" name="telefono" type="text" mask="(0\999)999-999" placeholder="(09**)999-999" defaultValue={this.props.phoneSelector}
              className="form-control input-box" onChange={this.onChange} required>
             
                </InputMask>
               
            </div>
            
          </div>
      </div>
    );
  }
}

